<xemex-dialog-shell [title]="'header.userMenu.about' | translate">
  <div class="flex flex-col items-center text-center">
    <div class="mb-6 flex h-40 w-40 items-center justify-center rounded-3xl bg-white p-4">
      <img src="assets/logo/logo.svg" alt="Xemex logo" width="140" height="auto" />
    </div>

    <h3 class="mb-4 text-[1.75rem] font-semibold text-black">
      {{ 'about.title' | translate: { name: data.appName } }}
    </h3>

    <p class="mb-6 max-w-[420px] text-body font-light text-neutral">
      {{ data.aboutText }}
    </p>

    <div class="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-body">
      <a
        [href]="data.privacyPolicyUrl"
        target="_blank"
        rel="noopener"
        class="text-primary hover:underline hover:underline-offset-1"
      >
        {{ 'general.privacyPolicy' | translate }}
      </a>
      <span class="text-neutral">&bull;</span>
      <a
        [href]="data.termsUrl"
        target="_blank"
        rel="noopener"
        class="text-primary hover:underline hover:underline-offset-1"
      >
        {{ 'about.termsAndConditions' | translate }}
      </a>
      <span class="text-neutral">&bull;</span>
      <a
        [href]="data.websiteUrl"
        target="_blank"
        rel="noopener"
        class="text-primary hover:underline hover:underline-offset-1"
      >
        {{ websiteLabel }}
      </a>
    </div>
  </div>

  <div actions>
    <xemex-filled-button (click)="close()">
      {{ 'general.btnClose' | translate }}
    </xemex-filled-button>
  </div>
</xemex-dialog-shell>
